import React, { useState, useContext, useEffect } from 'react';
import { styled } from '@mui/system';
import {
  Card, CardContent, CardHeader,
} from '@mui/material';
import CustomTable from '../../components/table/CustomTable';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { NotificationContext } from '../../contexts/Notification';
import { timeToDate } from '../../utils/time';
import Activity from '../../images/activity.png';

const CustomCard = styled(Card)`
    borderRadius: "8px",
    width: 30%,
    border: "1px solid var(--Dark-Dark-06, #E0E1E6)",
    boxShadow: "none"
`;

const FIXED_TABLE_HEADERS = [
  {
    label: 'Activity',
    sortable: false,
  },
  {
    label: 'Date',
    sortable: false,
  },
  {
    label: 'User',
    sortable: false,
  },
  {
    label: 'Type',
    sortable: false,
  },
];

function ActivitiesCard() {
  const { displayNotification } = useContext(NotificationContext);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchActivityLogs = async () => {
    setLoading(true);
    const { success, data } = await sendRequest({
      method: 'get',
      url: API.MEMBER.activityLogs(),
      timeout: 30000,
    });
    if (success) {
      const tempData = [];
      data.activityLogs.forEach((item, index) => {
        if (index < 5) {
          const datum = {
            activity: item.event,
            date: timeToDate(item.date),
            user: item.user || item.role, // Show email if available, fallback to role
            type: item.eventType || item.module, // Show event type if available, fallback to module
            description: item.description,
          };
          tempData.push(datum);
        }
      });
      setTableData(tempData);
      setLoading(false);
    } else {
      displayNotification({
        message: 'There was an issue fetching activity log data. Please try again',
        severity: 'error',
      });
    }
  };

  useEffect(() => {
    fetchActivityLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CustomCard className="daily-activities-card" style={{ position: 'relative' }}>
      <CardHeader
        className="table-card-header hours-card-header"
        title={(
          <div className="table-card-header-title d-flex gap-1 justify-content-between align-items-center">
            <div className="table-card-logo d-flex gap-1">
              <img
                src={Activity}
                alt="info icon"
                style={{
                  width: '23px',
                  height: '34px',
                  marginTop: '4px',
                }}
              />
              <p>Recent Activities</p>
            </div>
          </div>
        )}
      />
      <CardContent className="table-card-content d-flex flex-column justify-content-between">
        <CustomTable headers={FIXED_TABLE_HEADERS} items={tableData} loading={loading} />
      </CardContent>
    </CustomCard>
  );
}

export default ActivitiesCard;
